export default "assets/frame-5.e4caba6ce69e65aa.png"